exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inactive[data-v-1a30bf01] {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.material-icons[data-v-1a30bf01] {\n  font-size: 30px;\n  line-height: 30px;\n}\n.pagination-page a[data-v-1a30bf01]:hover {\n  background-color: #333;\n  color: #fff;\n}\n@media (max-width: 767px) {\n.pagination-page[data-v-1a30bf01] {\n    margin: 0;\n}\n}\n@media (max-width: 767px) {\n.pagination-page a[data-v-1a30bf01], .pagination-page span[data-v-1a30bf01] {\n    padding: 10px 12px;\n    font-size: 16px;\n}\n}\n", ""]);

// exports
